import React, { useEffect, useState } from "react";
import {
  ButtonContainer,
  ImageHelper,
  ItemPrefeitura,
  LogoPrefeitura,
  TitlePrefeitura,
  PrefeituraButton,
  ModalContainer,
  TableContainer,
  ButtonsContainer,
} from "./styles";
import { ChevronDown, HelpCircle } from "react-feather";
import { IPrefeitura, usePrefeitura } from "../../Hooks/usePrefeitura";
import { useCartorio } from "../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../Hooks/funcionarioCartorio";
import { ModalDivX } from "../ModalDivX";
import Modal from "react-modal";
import theme from "../../Styles/theme";
import { logos } from "../../Utils/baseUrlLogos";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  initialValue: number;
  execute(pref: IPrefeitura): void;
}

export function MunicipioSelector({ initialValue, execute }: Props) {
  const [municipio, setMunicipio] = useState({} as IPrefeitura);
  const { cartorioIsLogged, checarToken, cartorio } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  const { prefeituras, getPrefeituras, assets } = usePrefeitura();
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState("");

  useEffect(() => {
    if (prefeituras && assets) {
      if (prefeituras.length > 0 && assets.length > 0) {
        const teste = prefeituras.find((item) => item.ID == initialValue);
        if (teste) {
          execute(teste);
          setMunicipio(teste);
          setLogo(`${logos}/uploads/${assets[defineLogo(teste.ID)].logo}`);
        }
      }
    }
  }, [initialValue, prefeituras, assets]);

  async function loadData() {
    try {
      if (funcionarioCartorioIsLogged) {
        await checarTokenFuncionario();
      } else {
        checarToken();
      }
      if (
        (!prefeituras || prefeituras[0] == undefined) &&
        (!assets || assets[0] == undefined)
      ) {
        await getPrefeituras(cartorio.ID);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  function defineLogo(id: number): number {
    let index = 0;
    if (assets) {
      if (assets.length > 0) {
        index = assets.findIndex((item) => item.id == id);
      }
    }
    return index;
  }
  function renderPrefeituras() {
    if (prefeituras && assets) {
      if (prefeituras.length > 0 && assets.length > 0) {
        return prefeituras.map((item) => {
          if (item.STATUS != null)
            if (item.STATUS.trim().toUpperCase() == "A")
              return (
                <PrefeituraButton
                  onClick={() => {
                    execute(item);
                    setMunicipio(item);
                    setLogo(
                      `${logos}/uploads/${assets[defineLogo(item.ID)].logo}`
                    );
                    setOpenModal(false);
                  }}
                >
                  <ItemPrefeitura focus={item.ID == municipio.ID}>
                    <ImageHelper>
                      {" "}
                      <LogoPrefeitura
                        src={`${logos}/uploads/${
                          assets[defineLogo(item.ID)].logo
                        }`}
                        alt=""
                      />{" "}
                    </ImageHelper>
                    <TitlePrefeitura>{item.NOME}</TitlePrefeitura>
                  </ItemPrefeitura>
                </PrefeituraButton>
              );
        });
      }
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  return <>{renderPrefeituras()}</>;
}
